import { GENDERS, USER_TYPES } from "../constants";

export const attrs_input = {
    dense: true,
    outlined: true,
    hideDetails: true,
    persistentPlaceholder: true,
    attach: true,
};

export const attrs_input__verticalTable = {
    flat: true,
    solo: true,
    class: "rounded-0",
    hideDetails: true,
    "persistent-placeholder": true,
};

export const attrs_table = {
    "disable-sort": true,
    "disable-pagination": true,
    "hide-default-footer": true,
};

export const attrs_switch = {
    inset: true,
    hideDetails: "auto",
};
export const attrs_switch__console = {
    inset: true,
    hideDetails: "auto",
    class: "pa-0 ma-0 d-inline-block mr-n4",
};

const digitLengthOf = (value) => value.replaceAll(/\D/g, "").length;

export const rules = {
    username: [(value) => !/[^a-z\d]/.test(value) || "아이디를 영문 소문자 및 숫자로만 작성해주세요", (value) => (value && value?.length > 3) || "아이디를 4자 이상으로 작성해주세요"],
    password: [(value) => /[~!@#$%^&*()_+|<>?:{}]/.test(value) || "비밀번호에 특수문자를 넣어주세요", (value) => /[a-zA-Z]/.test(value) || "비밀번호에 영문을 넣어주세요", (value) => /[0-9]/.test(value) || "비밀번호에 숫자를 넣어주세요", (value) => (value && 8 <= value.length && value.length <= 16) || "비밀번호를 8 ~ 16자 사이로 작성해주세요"],
    phone: [(value) => (value && [10, 11].includes(digitLengthOf(value))) || "휴대전화번호를 입력해주세요"],
    email: [(value) => (value && /[^@]+@[^@]+\.[^@]+/.test(value)) || "이메일을 입력해주세요"],

    [USER_TYPES.PERSON.value]: {
        name: [(value) => (value && 1 < value?.length) || "이름을 입력해주세요"],
        bornAt: [(value) => (value && digitLengthOf(value) == 8) || "생년월일을 입력해주세요"],
        gender: [(value) => (value && Object.keys(GENDERS).includes(value)) || "성별을 선택해주세요"],
    },

    [USER_TYPES.COMPANY.value]: {
        name: [(value) => (value && 0 < value?.length) || "기업명을 입력해주세요"],
        businessRegistration: [(value) => !!value || "사업자등록증을 첨부해주세요"],
        ceoName: [(value) => (value && 1 < value?.length) || "대표자 성명을 입력해주세요"],
    },
};
